import {
  GET_PRESTATIONS,
  GET_PRESTATIONS_FAIL,
  GET_PRESTATIONS_SUCCESS,
  ADD_NEW_PRESTATION,
  ADD_PRESTATION_SUCCESS,
  ADD_PRESTATION_FAIL,
  UPDATE_PRESTATION,
  UPDATE_PRESTATION_SUCCESS,
  UPDATE_PRESTATION_FAIL,
  DELETE_PRESTATION,
  DELETE_PRESTATION_SUCCESS,
  DELETE_PRESTATION_FAIL,
  
} from "./actionTypes";

export const getPrestations = () => ({
  type: GET_PRESTATIONS,
})

export const getPrestationsSuccess = (prestations) => ({
  type: GET_PRESTATIONS_SUCCESS,
  payload: prestations,
})

export const getPrestationsFail = error => ({
  type: GET_PRESTATIONS_FAIL,
  payload: error,
})

export const addNewPrestation = (prestation) => ({
  type: ADD_NEW_PRESTATION,
  payload: prestation,
})

export const addPrestationSuccess = (prestation) => ({
  type: ADD_PRESTATION_SUCCESS,
  payload: prestation,
})

export const addPrestationFail = error => ({
  type: ADD_PRESTATION_FAIL,
  payload: error,
})

export const updatePrestation = (prestation) => ({
  type: UPDATE_PRESTATION,
  payload: prestation,
})

export const updatePrestationSuccess = (prestation) => ({
  type: UPDATE_PRESTATION_SUCCESS,
  payload: prestation,
})

export const updatePrestationFail = error => ({
  type: UPDATE_PRESTATION_FAIL,
  payload: error,
})

export const deletePrestation = (prestation) => ({
  type: DELETE_PRESTATION,
  payload: prestation,
})

export const deletePrestationSuccess = (prestation) => ({
  type: DELETE_PRESTATION_SUCCESS,
  payload: prestation,
})

export const deletePrestationFail = error => ({
  type: DELETE_PRESTATION_FAIL,
  payload: error,
})

